import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight, CheckCircle2, MessageCircle } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, whatsappUrl } from '@/config/site';

const benefits = [
  'Integração completa PDV + Conciliação + Fidelidade',
  'Suporte especializado em postos de combustível',
  'Implementação em menos de 7 dias úteis',
  'Sem fidelidade — cancele quando quiser',
];

export default function ContatoPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen relative overflow-hidden font-['Inter',sans-serif]">
      <div className="absolute inset-0 z-0">
        <img
          src="/lukos_conciliacao_woman_premium.png"
          alt="Lukos Tecnologia"
          className="w-full h-full object-cover object-center scale-105"
        />
        <div className="absolute inset-0 bg-black/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-black/40" />
      </div>

      <nav className="relative z-10 flex items-center justify-between px-8 py-5">
        <Link to="/">
          <img src="/logobranco.svg" alt="Lukos" className="h-8 w-auto" />
        </Link>
        <Link to="/" className="text-white/50 hover:text-white text-sm font-medium transition-colors">
          ← Voltar ao site
        </Link>
      </nav>

      <div className="relative z-10 min-h-[calc(100vh-72px)] flex items-center">
        <div className="w-full max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h1
                className="text-5xl md:text-[58px] font-black text-white leading-[1.06] tracking-tight mb-6"
                style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-0.03em' }}
              >
                Automatize seu posto.<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white/80 to-white/40 font-light">
                  Escale seus resultados.
                </span>
              </h1>

              <p className="text-white/55 text-lg leading-relaxed mb-10 max-w-lg">
                Converse com um especialista Lukos e descubra como integrar PDV,
                conciliação bancária e fidelidade em uma única plataforma — sem complicações.
              </p>

              <div className="space-y-4 mb-10">
                {benefits.map((b, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 + i * 0.1 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle2 size={17} className="text-white/70 shrink-0" />
                    <span className="text-white/65 text-sm font-medium">{b}</span>
                  </motion.div>
                ))}
              </div>

              <div className="flex flex-wrap gap-6 text-sm">
                <a
                  href={whatsappUrl('Olá, gostaria de falar sobre a Lukos.')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/50 hover:text-white transition-colors"
                >
                  <MessageCircle size={15} className="text-green-400" />
                  (11) 97874-7233
                </a>
                <a href={PHONE_HREF} className="flex items-center gap-2 text-white/50 hover:text-white transition-colors">
                  <Phone size={15} className="text-white/40" />
                  {PHONE_DISPLAY}
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              <div className="bg-white rounded-3xl shadow-[0_40px_100px_rgba(0,0,0,0.4)] p-8 md:p-10">
                <div className="mb-8">
                  <h2 className="text-2xl font-black text-slate-900 mb-2 tracking-tight">
                    Fale com um especialista agora
                  </h2>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    O atendimento comercial é pelo WhatsApp. Conte o que precisa e um especialista Lukos retoma o contato.
                  </p>
                </div>

                <a
                  href={whatsappUrl('Olá, gostaria de falar com um especialista sobre a Lukos.')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-black py-4 rounded-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:shadow-green-900/20 flex items-center justify-center gap-3 text-[15px]"
                >
                  <MessageCircle size={18} />
                  Falar agora pelo WhatsApp
                  <ArrowRight size={17} />
                </a>

                <a
                  href={PHONE_HREF}
                  className="mt-4 w-full border border-slate-200 hover:border-slate-300 text-slate-700 font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-3 text-[15px]"
                >
                  <Phone size={17} />
                  Ligar {PHONE_DISPLAY}
                </a>

                <p className="text-[11px] text-slate-400 text-center leading-relaxed pt-6">
                  Segunda a sexta, das 08h30 às 17h30. Sem cadastro e sem envio automático de dados.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
